'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function toPathComponents() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (path.trim().match(/([^\\^/]|\\\/)+/g) || []).filter(Boolean);
}

exports.toPathComponents = toPathComponents;